// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--o4EfH","seo-text":"_1410bfd27b--seo-text--j8oiM"};